export const HIDE_DROPDOWNS_EVENT = 'hide-all-dropdowns';
